// Menu data extracted from Pedix app
export const menuItems = [
  // BURGERS
  {
    id: 1,
    name: "MOTA DE MISTER",
    price: 10990,
    category: "burger",
    description: "Nuestra burger insignia con ingredientes premium",
    image: "/images/burgers/mota-de-mister.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/BEVbxsTCuENwtr_iYcFSe.png?size=2000x2000"
  },
  {
    id: 2,
    name: "ARGENTA",
    price: 10990,
    category: "burger",
    description: "Burger con sabores argentinos auténticos",
    image: "/images/burgers/argenta.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/WIFSsI-gfTU5136rDhpkS.png?size=2000x2000"
  },
  {
    id: 3,
    name: "PROVOLETA",
    price: 10990,
    category: "burger",
    description: "Deliciosa burger con provoleta derretida",
    image: "/images/burgers/provoleta.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/EJK2Sdsupf1DCn4oN9Aa9.png?size=2000x2000"
  },
  {
    id: 4,
    name: "ROQUEFELLER",
    price: 10990,
    category: "burger",
    description: "Burger gourmet con queso roquefort",
    image: "/images/burgers/roquefeller.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/uwsFoI5RKY1jaBLeKSKz9.png?size=2000x2000"
  },
  {
    id: 5,
    name: "CHICAGO",
    price: 12990,
    category: "burger",
    description: "Estilo Chicago con ingredientes premium",
    image: "/images/burgers/chicago.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/IvVdSorfY4seYR5nzbPtd.png?size=2000x2000"
  },
  {
    id: 6,
    name: "LA PEPI",
    price: 10990,
    category: "burger",
    description: "Burger especial de la casa",
    image: "/images/burgers/la-pepi.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/EnT8bpZjX15WvQSlA7lDA.png?size=2000x2000"
  },
  {
    id: 7,
    name: "PATY MELT",
    price: 10990,
    category: "burger",
    description: "Clásica paty melt con queso derretido",
    image: "/images/burgers/paty-melt.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/XOiiw8APcwioIoRwQtixk.png?size=2000x2000"
  },
  {
    id: 8,
    name: "NEW YORK CITY",
    price: 10990,
    category: "burger",
    description: "Estilo neoyorquino auténtico",
    image: "/images/burgers/new-york-city.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/McVZj-TGRjpTyAOMHNeQC.png?size=2000x2000"
  },
  {
    id: 9,
    name: "MEXICAN SPICY",
    price: 10990,
    category: "burger",
    description: "Burger picante con sabores mexicanos",
    image: "/images/burgers/mexican-spicy.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/KqAKIe17GhAFo_QomgoB4.png?size=2000x2000"
  },
  {
    id: 10,
    name: "CHEESE BURGER",
    price: 10990,
    category: "burger",
    description: "Clásica cheeseburger perfecta",
    image: "/images/burgers/cheese-burger.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/YZF5mQn931bFcM_1L9828.png?size=2000x2000"
  },
  {
    id: 11,
    name: "SIMPLES",
    price: 8500,
    category: "burger",
    description: "Burger simple pero deliciosa",
    image: "/images/burgers/simples.jpg",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/3hHBsxOzM9WqYr7MrH5YU.png?size=2000x2000"
  },

  // LOMOS
  {
    id: 12,
    name: "LOMO MISTER",
    price: 12900,
    category: "lomo",
    description: "Pan casero, alioli, pimientos asados, cebolla asada, queso cheddar, bife de lomo de 150g, acompañado con papas fritas.",
    image: "/images/lomos/lomo-mister.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/7WHe8G_1MlcTOlCvrVJWh.png?size=2000x2000"
  },
  {
    id: 13,
    name: "LOMO ARGENTO",
    price: 12900,
    category: "lomo",
    description: "Pan casero, criolla, alioli,tomate, queso dambo, panceta,lechuga, bife de lomo de 150g, acompañado de papas fritas.",
    image: "/images/lomos/lomo-argento.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/zGhQ-MVDss1mtEdCsgg1x.png?size=2000x2000"
  },
  {
    id: 14,
    name: "LOMO COMPLETO",
    price: 12900,
    category: "lomo", 
    description: "Pan casero, alioli, lechuga,tomate, queso dambo, huevo, bife de lomo de 150g, acompañado de papas fritas.",
    image: "/images/lomos/lomo-completo.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/1rZfkSiDcWN_G9X9vcG4c.png?size=2000x2000"
  },

  // WRAPS / BURRITOS
  {
    id: 16,
    name: "TERNERA DESMENUZADA",
    price: 10990,
    category: "wrap",
    description: "Lechuga, alioli, cebolla caramelizada, pimientos asados, queso dambo y marucha desmenuzada acompañado con papas fritas o nachos",
    image: "/images/wraps/ternerna-desmenuzada.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/5LTNreTf1F-gj4eYCSq_S.png?size=2000x2000"
  },
  {
    id: 17,
    name: "POLLO CALIENTE",
    price: 10990,
    category: "wrap",
    description: "Rucula, alioli, crutones, pollo en cubos, queso dambo y cebolla caramelizada acompañado con papas fritas o nachos.",
    image: "/images/wraps/pollo-caliente.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/hC6kOlFHpHws_qdUIHFd3.png?size=2000x2000"
  },
  {
    id: 18,
    name: "SUPREMO MILA",
    price: 10990,
    category: "wrap",
    description: "Lechuga, palta ,crutones, pollo en cubos,aderezo mister, queso dambo,cebolla morada, choclo y  tomate en cubos acompañado con papas fritas o nachos.",
    image: "/images/wraps/supremo-mila.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/DPNhVnRKg81woZVQ0xhnY.png?size=2000x2000"
  },
  {
    id: 19,
    name: "BONDIOLA DESMENUZADA",
    price: 10990,
    category: "wrap",
    description: "Mix de verdes,alioli, cebolla caramelizada, pimientos asados, queso dambo y bondiola desmenuzada acompañado con papas fritas o nachos.",
    image: "/images/wraps/bondiola-desmenuzada.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/pHem2wB7Vs0QAY4_I9Cc5.png?size=2000x2000"
  },

  // ENSALADAS
  {
    id: 20,
    name: "ENSALADA MISTER",
    price: 6500,
    category: "ensalada",
    description: "Mix de verdes, tomate en cubo, zanahoria rallada,pollo en cubos,aderezo mister,queso parmesano y crutones.",
    image: "/images/ensaladas/ensalada-mister.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/ooyWMRuQRrVOb2qzu8k5F.png?size=2000x2000"
  },
  {
    id: 21,
    name: "ENSALADA CESAR",
    price: 7500,
    category: "ensalada",
    description: "Mix de verdes, pollo en cubos, creutones, queso parmesano, panceta y aderezo mister.",
    image: "/images/ensaladas/ensalada-cesar.png",
    imageUrl: "https://cdn.pedix.app/LfpDb21EG9Y8ktdDaiV9/products/QhCdanolfh7mh-8-QSJwt.png?size=2000x2000"
  },


];

export const menuCategories = [
  { id: 'burger', name: 'BURGERS', icon: '🍔' },
  { id: 'lomo', name: 'LOMOS', icon: '🥪' },
  { id: 'wrap', name: 'WRAPS / BURRITOS', icon: '🌯' },
  { id: 'ensalada', name: 'ENSALADAS', icon: '🥗' }
];

export const formatPrice = (price) => {
  return `$${price.toLocaleString('es-AR')}`;
};

export const locationInfo = {
  address: "Mota Botello 320, San Fernando del Valle de Catamarca, Catamarca, 4751",
  city: "San Fernando del Valle de Catamarca",
  province: "Catamarca",
  country: "Argentina",
  phone: "3834-06-4747",
  whatsapp: "+54 9 3834 06 4747",
  hours: "Todos los días de 20:00 a 24:00"
};
